import qs from 'qs'
import request from 'api/requestUtils'
import config from 'constants/config'
import { operations } from '@luxuryescapes/contract-svc-promo/generated'

export type WhiteLabelAppPromoResponse = operations['/api/promo/external-promo-codes/assign/post']['responses']['201']['content']['application/json']

export async function getWhiteLabelAppPromoByMemberId({ memberId, externalProviderName }: { memberId: string, externalProviderName: string }) {
  const params = qs.stringify({
    user_id: memberId,
    external_provider_name: externalProviderName,
    brand: config.BRAND,
  })

  return request.post<WhiteLabelAppPromoResponse, undefined>(`/api/promo/external-promo-codes/assign?${params}`, undefined, { credentials: 'include' })
    .then((response) => ({ promoCode: response.result }))
}

export function patchIgnoreWhiteLabelAppPromoForMemberId({ memberId, promoCode }: { memberId: string, promoCode: string }) {
  const params = qs.stringify({
    user_id: memberId,
    promo_code: promoCode,
  })

  return request.patch(`/api/promo/external-promo-codes/ignore?${params}`, undefined, { credentials: 'include' })
}
